export default class IHistory {

  links = [];
  history = {
    states: []
  };

  // constructor(links) {
  //   this.links = links;
  // }

  setLinks(links) {
    this.links = links;
  }

  saveCurrentState() {
    this.history.states.push(this.serialize(this.links));
    return true;
  }

  restoreLastState() {
    const lastState = this.history.states.pop();
    if(!lastState) return false;
    this.deserialize(lastState).forEach((s, i) => this.links[i] = s);
    return true;
  }

  serialize(o) {
    return JSON.stringify(o);
  }

  deserialize(o) {
    return JSON.parse(o);
  }

}



// WEBPACK FOOTER //
// ./src/interfaces/IHistory.js